module.exports = __webpack_public_path__ + "img/chapter-2-thumb.2fb0d43d.jpg";